"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const heroImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/crooked_river_aerial_view.png",
  alt: "The majestic bamboo architecture of Bulwagan Hall at Ubud Event Space"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/campground_swimming_pool.png",
  alt: "Intimate private dining setup within the organic bamboo structures"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/lakeside_camping_spots.png",
  alt: "Scenic view of the bamboo venue overlooking the lush Peliatan rice fields"
}];
export default function RiverfrontEscapeHero() {
  return <section data-section-id="113346" id="bulwagan-architectural-elegance" className="w-full relative bg-background text-foreground">
      <style>{`
        @keyframes kenBurnsZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.05); }
        }
        .animate-ken-burns {
          animation: kenBurnsZoom 8s ease-in-out infinite alternate;
        }
      `}</style>

      <Carousel opts={{
      loop: true,
      align: "start"
    }} className="w-full">
        <CarouselContent className="ml-0">
          {heroImages.map((image, index) => <CarouselItem key={index} data-index={index} className="pl-0 relative h-[60vh] min-h-[500px] md:h-[80vh] w-full overflow-hidden">
              <img src={image.src} alt={image.alt} className="absolute inset-0 w-full h-full object-cover animate-ken-burns" />
            </CarouselItem>)}
        </CarouselContent>
        
        <CarouselPrevious className="left-4 md:left-8 bg-primary/40 text-primary-foreground border-none hover:bg-primary/60 size-12 [&_svg]:size-8 transition-all duration-300 backdrop-blur-sm shadow-lg" variant="outline" />
        <CarouselNext className="right-4 md:right-8 bg-primary/40 text-primary-foreground border-none hover:bg-primary/60 size-12 [&_svg]:size-8 transition-all duration-300 backdrop-blur-sm shadow-lg" variant="outline" />
      </Carousel>
    </section>;
}